"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _underscore = require("underscore");

var _GoodImageTypes = _interopRequireDefault(require("marketplace-lib/constants/GoodImageTypes"));

var _GoodSubTypes = _interopRequireDefault(require("../../constants/GoodSubTypes"));

var _utils = require("../../utils/utils");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _GoodTile = _interopRequireDefault(require("marketplace-lib/components/goods/GoodTile"));

var _GoodTileLink = _interopRequireDefault(require("../GoodTileLink"));

var _withPartials = _interopRequireDefault(require("marketplace-lib/components/hocs/withPartials"));

var _GoodSubTypeDropdown = _interopRequireDefault(require("../GoodSubTypeDropdown"));

var getI18nKey = (0, _underscore.memoize)(function (path) {
  return "MarketplaceUI.goodDetailsPage.packContents." + path;
});

var PackContents =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PackContents, _PureComponent);

  function PackContents(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PackContents);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PackContents).call(this, props));
    _this.handleSubTypeChange = _this.handleSubTypeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      selectedSubType: _GoodSubTypes.default.ALL
    };
    return _this;
  }

  (0, _createClass2.default)(PackContents, [{
    key: "handleSubTypeChange",
    value: function handleSubTypeChange(event) {
      this.setState({
        selectedSubType: event.target.value
      });
    }
  }, {
    key: "renderPackChildLink",
    value: function renderPackChildLink(urlToken, props) {
      return _react.default.createElement(_GoodTileLink.default, (0, _extends2.default)({}, props, {
        goodUrlToken: urlToken
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          goodDetails = _this$props.goodDetails,
          packChildrenSubTypes = _this$props.packChildrenSubTypes,
          partial = _this$props.partial,
          previewMode = _this$props.previewMode,
          trackLinkClick = _this$props.trackLinkClick;
      var selectedSubType = this.state.selectedSubType;
      var packChildren = goodDetails.get('children');
      var filteredPackChildren = packChildren.filter(function (child) {
        if (selectedSubType === _GoodSubTypes.default.ALL) {
          return true;
        }

        return child.get('subType') === selectedSubType;
      });
      return _react.default.createElement("div", {
        className: "pack-contents",
        "data-test-id": "pack-contents"
      }, packChildrenSubTypes && packChildrenSubTypes.length > 1 && _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIFlex.default, {
        align: "baseline",
        justify: "between"
      }, _react.default.createElement(_GoodSubTypeDropdown.default, {
        buttonClassName: "integrate-pack-contents-filter",
        onSubTypeChange: this.handleSubTypeChange,
        subTypeOptions: packChildrenSubTypes,
        value: selectedSubType
      }), _react.default.createElement(_FormattedHTMLMessage.default, {
        message: getI18nKey('filteredCount'),
        options: {
          filteredCount: filteredPackChildren.size,
          totalCount: packChildren.size
        }
      }))), _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIGrid.default, null, filteredPackChildren.map(function (child, index) {
        var childUrlToken = child.get('urlToken');
        return _react.default.createElement(_UIGridItem.default, {
          key: index,
          size: {
            xs: 4
          }
        }, _react.default.createElement(_GoodTile.default, {
          goodImageUrl: child.getIn(['images', _GoodImageTypes.default.MARKETING_IMAGE_SMALL]),
          goodName: (0, _utils.getEnglishTextFieldFromTextsMap)('NAME', child.get('texts')),
          goodPrice: child.get('price'),
          goodSubType: child.get('subType'),
          goodType: child.get('type'),
          goodUrlToken: childUrlToken,
          linkRenderer: partial(_this2.renderPackChildLink, childUrlToken),
          onClick: partial(trackLinkClick, 'good-tile'),
          onPackDetailsPage: true,
          previewMode: previewMode
        }));
      }))));
    }
  }]);
  return PackContents;
}(_react.PureComponent);

PackContents.propTypes = {
  goodDetails: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  packChildrenSubTypes: _propTypes.default.arrayOf(_propTypes.default.string),
  partial: _propTypes.default.func.isRequired,
  previewMode: _propTypes.default.bool.isRequired,
  trackLinkClick: _propTypes.default.func.isRequired
};

var _default = (0, _withPartials.default)(PackContents);

exports.default = _default;
module.exports = exports.default;